import React from 'react';

import { Group, Text } from '@mantine/core';
import { AthleteAppointmentMeta } from 'hooks/athleteAppointment/useAthleteAppointmentMeta';

interface AthleteAppointmentStateLabelProps {
  athleteAppointmentMeta: AthleteAppointmentMeta;
  size?: 'md' | 'lg' | 'xl';
}

const AthleteAppointmentStateLabel = ({
  athleteAppointmentMeta,
  size = 'md',
}: AthleteAppointmentStateLabelProps): JSX.Element => {
  const { stateText, color, Icon = null } = athleteAppointmentMeta;
  const spacing = size === 'md' ? 4 : size === 'lg' ? 6 : 8;
  const iconSize = size === 'md' ? 16 : size === 'lg' ? 20 : 24;

  return (
    <Text weight='bold' color={color} size={size}>
      <Group spacing={spacing} align='center' pr={Icon ? spacing : 0}>
        {Icon && <Icon size={iconSize} />}
        {stateText}
      </Group>
    </Text>
  );
};

export default AthleteAppointmentStateLabel;
